import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Grid,
  Button,
  Chip,
  Tooltip,
} from '@mui/material';
import createToast from 'components/Toast/Toast';
import { makeStyles } from '@mui/styles';
import { validator } from 'myValidation';
import { ButtonLoading, Icons, InputV2 } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
export default function SendEmailDg({ open, setOpen, onSendEmail, isSubmitingEmail }) {
  useEffect(() => {
    !open && restData();
  }, [open]);
  const classes = useStyles();
  const methods = useForm();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [emali, setEmail] = useState('');
  const [indexArray, setIndexArray] = useState(null);
  const restData = () => {
    setEmail('');
    setSelectedEmails([]);
  };

  const checkEmail = () => {
    if (validator.isEmail(String(emali).trim())) {
      if (selectedEmails.length > 4) {
        createToast('خطا', 'امکان ارسال به بیشتر از 5 ایمیل وجود ندارد.', 'danger');

        return;
      }
      if (selectedEmails.find((a) => a == emali.toLocaleLowerCase())) {
        createToast('خطا', 'ایمیل تکراری است.', 'danger');

        return;
      }
      setSelectedEmails((p) => [...p, String(emali.toLocaleLowerCase()).trim()]);
      setEmail('');
    } else {
      if (!String(emali).trim()) {
        return;
      }

      createToast('خطا', 'لطفا ایمیل را بدرستی وارد نمایید.', 'danger');

      return;
    }
  };
  return (
    <FormProvider {...methods}>
      <Dialog
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="xs"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.dialogTitle}
        >
          اشتراک گذاری
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            size="large">
            <Icons icon='Close' color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            item
            className={classes.root}
          >
            <Grid item container xs={12}>
              <Grid item xs={12} lg={12}>
                <Grid item lg={9} xs={12} className={classes.fromEmail}>
                  <div className={classes.titleTooltip}>
                    <span style={{ margin: '0 8px' }}>از :</span>
                  </div>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label=""
                    name="fromEmail"
                    register={methods.register}
                    disabled={true}
                    value="no-reply@pod.ir"
                    forceValue="no-reply@pod.ir"
                    mainStyle={{ backgroundColor: '#ededed', borderRadius: '4px' }}
                  />
                </Grid>
                <Grid container className={classes.addEmail}>
                  <Grid className={classes.textEmail}>
                    <div className={classes.titleTooltip}>
                      <span style={{ margin: '0 8px' }}>به :</span>
                      <Tooltip
                        placement="left-start"
                        title="امکان افزودن حداکثر 5 ایمیل وجود دارد!"
                      >
                        <span style={{ marginTop: '5px' }}>
                          <Icons icon='Info' color="#2B3990" size="20" />
                        </span>

                      </Tooltip>
                    </div>
                    <InputV2
                      disabled={false}
                      fullWidth
                      errors={methods.formState.errors}
                      label=""
                      name="email"
                      placeholder="لطفا ایمیل را وارد نمایید"
                      register={methods.register}
                      defaultValue={emali}
                      style={{ direction: 'ltr' }}
                      forceValue={emali}
                      onChangeValue={(v) => {
                        setEmail(String(v?.target?.value).trim());
                      }}
                      onKeyDown={(e) => {
                        if (e?.keyCode === 13) {
                          checkEmail();
                        }
                      }}
                      mainStyle={{ borderColor: '#8f8f8f' }}
                    />
                  </Grid>
                  <Grid className={classes.addIcon}>
                    <ButtonLoading
                      color="primary"
                      variant="outlined"
                      name={
                        <>
                          افزودن <span style={{ marginRight: '4px', marginTop: '10px' }}> <Icons icon='plusCircle' color={!emali ? '#ccc' : "#2B3990"} size="16" /></span>
                        </>
                      }
                      onClick={(e) => {
                        checkEmail();
                      }}
                      disabled={!emali}
                      className={classes.btn100}
                    />
                  </Grid>
                </Grid>
                <Grid item md={12} xs={12} className={classes.mrTop}>
                  {selectedEmails?.map((t, i) => (
                    <Chip
                      key={i + t}
                      onDelete={() => {
                        setSelectedEmails((pre) => pre.filter((p, index) => i !== index));
                        setIndexArray(null);
                      }}
                      onClick={() => {
                        setEmail(selectedEmails[i]);
                        setIndexArray(i);
                      }}
                      label={t}
                      className={classes.customChip}
                    />
                  ))}
                </Grid>

                <Grid item md={12} xs={12} className={classes.attachBox}>
                  <Icons icon='attachment' color="#2B3990" size="18" />
                  <span className={classes.attachFile}>ایمیل حاوی فایل پیوست شده میباشد</span>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                flexDirection: 'row-reverse',
                marginTop: '16px',
                gap: '15px',
              }}
            >
              <ButtonLoading
                variant="contained"
                color="primary"
                onClick={() => onSendEmail(selectedEmails)}
                name="ارسال"
                loading={isSubmitingEmail}
                disabled={isSubmitingEmail || !selectedEmails.length}
              />
              <Button
                className={classes.cancelButton}
                variant="contained"
                onClick={() => setOpen(false)}
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </FormProvider>
  );
}

const useStyles = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  dialogTitle: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  cancelButton: {
    marginLeft: '5px',
  },
  addButton: {
    [theme.breakpoints.up('md')]: {
      transform: 'translate(5px, 31px)',
    },
  },
  customChip: {
    margin: '2px',
  },
  attachFile: {
    marginLeft: 8,
    fontSize: '11px',
    opacity: '0.8',
  },

  icoonAttchSize: {
    width: '0.8em',
    height: '0.8em',
    opacity: '0.8',
  },
  addEmail: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  textEmail: {
    flex: '8',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      flex: '1',
    },
  },
  addIcon: {
    margin: '30px 4px 0 4px',
    flex: '1',
    [theme.breakpoints.down('lg')]: {
      margin: '0',
      width: '100%',
      button: {
        width: '100%',
      },
    },
  },
  btn100: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  titleTooltip: {
    display: 'flex',
    marginLeft: '-8px',
  },
  attachBox: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      marginTop: '8px',
    },
  },
  mrTop: {
    [theme.breakpoints.down('lg')]: {
      marginTop: '8px',
    },
  },
  fromEmail: {
    [theme.breakpoints.down('xl')]: {
      width: '100%',
    },
  },
}));
